import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
    Table, CardBox,
    DropdownButton, SearchWithAction,
    EmptyState, Page
} from '../../components'
import { retrieve } from '../../actions/dictionary-actions'
import { push } from '../../actions/nav-actions'
import { deleteDictionary } from '../../api'
import { notify, testRegex } from '../../utils';
import Loader from '../../components/Loader'

class List extends Component {
    constructor(props) {
        super(props);
        this.state = {
            search: ''
        };
        this.renderChild = this.renderChild.bind(this);
        this.renderEmpty = this.renderEmpty.bind(this);
    }
    async componentDidMount() {
        this.props.retrieve(this.props.user.token)
    }
    renderEmpty() {
        return (
            <Loader/>
        )
    }
    renderChild() {
        return (
            [
                { Header: 'UID', accessor: '_id' },
                { Header: 'Language', accessor: 'lang' },
                {
                    Header: 'Created At',
                    id: 'cellDate',
                    accessor: d => new Date(d.created_at).toLocaleDateString()
                },
                {
                    Header: 'Options',
                    accessor: d => d,
                    className: "no-overflow",
                    id: 'options',
                    Cell: props => (
                        <DropdownButton
                            onActionClick={() => {
                                this.props.push(`/dictionaries/${props.value._id}`);
                            }}
                            icon="mdi mdi-account-box"
                            label="Edit">
                            <DropdownButton.Option
                                onClick={() => this.props.push(`/dictionaries/${props.value._id}`)}
                                icon="mdi mdi-pencil"
                                label="Edit" />
                            <DropdownButton.Option
                                onClick={() => {
                                    let confirm = window.confirm('Really wants to delete dictionary?');
                                    if (confirm) {
                                        deleteDictionary(this.props.user.token, props.value._id)
                                            .then((project) => this.props.retrieve(this.props.user.token))
                                            .catch((err) => notify(err.message))
                                    }
                                }}
                                icon="mdi mdi-delete"
                                label="Delete" />
                        </DropdownButton>
                    )
                }
            ]
        )
    }
    render() {
        let results = this.props.dictionaries.data.filter(i => testRegex(i._id, this.state.search));
        return (
            <Page title="Dictionaries">
                <SearchWithAction
                    action="CREATE DICTIONARY"
                    onActionClick={() => this.props.push('/dictionaries/new')}
                    onChange={search => this.setState({ search })} />
                <CardBox>
                    <Table
                        id="dictionaries"
                        renderEmpty={this.renderEmpty}
                        columns={this.renderChild()}
                        data={results} />
                </CardBox>
            </Page>
        )
    }
}


const mapStateToProps = state => ({
    user: state.authReducer.user,
    dictionaries: state.dictionaries
})

const mapDispatchToProps = dispatch => ({
    retrieve(token) {
        dispatch(retrieve(token));
    },
    push(routeName) {
        dispatch(push(routeName));
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(List);


// WEBPACK FOOTER //
// ./src/routers/Dictionaries/List.js